import { array, struct } from 'io-ts/Decoder';

import { Id as StatusId } from '../status/Id';

import { Id as StageId } from './Id';

export const FilterItem = struct({
	stageId: StageId,
	statusIds: array(StatusId),
});
